export class ToastUtils {
  public static readonly TITLE_SUCCESS = 'generic.message.toast.title.success';
  public static readonly TITLE_ERROR = 'generic.message.toast.title.error';
}
